import React from 'react';
import Box from '@mui/material/Box';
import Slider from '@mui/material/Slider';
import Typography from "@mui/material/Typography";

const marks = [
  {
    value: 0,
    label: '0%',
  },
  {
    value: 40,
    label: '40%',
  },
];

// Slider for Match
export default function DiscreteSliderLabel({onMatchChange, matchValue, selectedState}) {
  const isDisabled = selectedState === 'VI' || selectedState === 'PR';
  return (
    
    <Box sx={{ width: 340}}>
          <Typography id="non-linear-slider" gutterBottom sx={{ fontSize: '14px' }}>
            Match: <span style={{ fontWeight: 'bold' }}>{`${matchValue}%`}</span>
    </Typography>
    <Slider
      aria-labelledby="non-linear-slider"
      value={matchValue}
      min={0}
      step={1}
      max={40}
      marks={marks}
      onChange={onMatchChange}
      valueLabelDisplay="auto"
      disabled={isDisabled}
    />
    </Box>
  );
}